module.exports = __webpack_public_path__ + "img/double-next.01f6545e.svg";